import React from "react";

const investmentCrietria =
  "Growth Property Group specializes in the ownership and management of single-tenant net leased assets throughout the United States.  We seek high quality assets that have generally been overlooked or possess the potential for strong value creation.  GPG does not adhere to stringent parameters and can make decisions swiftly.  Our primary objective is to deliver risk-adjusted measured returns for our investors.  Listed below is our investment criteria.";

const criteriaList = [
  [
    "Investment Type",
    "Although our main focus is national and regional-branded net-leased retail properties, we also invest in restaurants (fast casual and quick service), grocery stores, and shopping centers.",
  ],
  [
    "Investment Size",
    "$500,000 - $10,000,000.",
  ],
  [
    "Location",
    "All states considered.",
  ],
  [
    "Market Rents",
    "Will only consider assets that are priced at or below market rent.",
  ],
  [
    "Tenant Credit",
    "We are able to evaluate all tenant types regardless of credit.  We take a real estate first approach.",
  ],
  [
    "Closing Procedures",
    "GPG prides itself on the ability to act decisively and close swiftly.",
  ],
];

const recentProperties = [
  ["Grocery Outlet", "Sparks, NV"],
  ["Filiberto's", "Avondale, AZ"],
  ["Wendy's", "Kalamazoo, MI"],
  ["Red Robin", "Wausau, WI"],
  ["Petco", "Hemet, CA"],
  ["Former Carl's Jr.", "Prescott, AZ"],
  ["Former Jack in the Box", "Peoria, AZ"],
  ["O'Reilly Auto", "Reno, NV"],
  ["LoanMax", "Fallon, NV"],
  ["Krispy Kreme", "Billings, MT"],
  ["Trulieve", "Scottsdale, AZ"],
  ["Red Lobster", "May's Landing, NJ"],
  ["Mattress Warehouse", "Vineland, NJ"],
  ["Dairy Queen", "Van Wert, OH"],
  ["Starbucks", "Kingsburg, CA"],
  ["Applebee's", "Sierra Vista, AZ"],
  ["Red Lobster", "Clovis, NM"],
  ["Jiffy Lube", "Huntington Beach, CA"],
  ["AT&T", "Clovis, NM"],
  ["Wesley Roger's Steak and Buffet", "Arnold, MO"],
  ["King Burrito", "Siloam Springs, AR"],
  ["Pennsylvania Liquor Control Board", "Glenside, PA"],
];

class AcquisitionCriteria extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="page-image" />
        <div className="container section row">
          <h5>Acquisition Criteria</h5>
          <div className="col s12 m6 l5">
            <h6>Investment Criteria</h6>
            <p>{investmentCrietria}</p>
            <br />
            <h6>Criteria</h6>
            {criteriaList.map((criteria, idx) => {
              return (
                <p className="bio" key={idx}>
                  <strong>{criteria[0]}:</strong>
                  &nbsp;{criteria[1]}
                </p>
              );
            })}
          </div>
          <div className="col s12 offset-m1 m5 offset-l2 l5">
            <h6>Recently completed transactions include:</h6>
            <ul>
              {recentProperties.map((property, idx) => {
                return (
                  <li key={idx}>
                    <strong>• {property[0]}</strong>&nbsp;
                    <span className="property-city">({property[1]})</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default AcquisitionCriteria;
